const LEADING_ARRAY = /\[/g;
      const TRAILING_ARRAY = /^\[|\]/g;
          
      const dot = (setting) =>
        setting.replace(TRAILING_ARRAY, '').replace(LEADING_ARRAY, '.').split('.');
      const pick = (obj, setting) => {
          try {
              return dot(setting).reduce((a, b) => a[b], obj);
          } catch (e) {
              return undefined;
          }
      };
      const config = {
  "api": {
    "url": "https://www.versorgungsatlas.de"
  }
};
      module.exports = { 
        ...config, 
        get: (setting) => pick(config, setting),
        has: (setting) => !!pick(config, setting),
      };